import * as React from "react";
import { SearchInput } from "@ic-anywhere/ic-components";
import { useSetAtom } from "jotai";
import { searchTermAtom } from "src/components/Event/Dashboard/utils/filtersAtom";
import EventsStatusButtonGroup from "./EventsStatusButtonGroup";
import { features } from "utils/logger/features";
import { featureTracking } from "components/common/event.tracking";

const DashboardFilters: React.FC = () => {
  const handleSearchTerm = useSetAtom(searchTermAtom);

  const debounceRef = React.useRef<NodeJS.Timeout | null>(null);
  const debouncedFeatureTrack = React.useCallback((value: string) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    debounceRef.current = setTimeout(() => {
      if (value && value.trim().length > 0) {
        featureTracking(features.welcomePageSearchFilter);
      }
    }, 1000);
  }, []);

  const handleSearch = (value: string) => {
    handleSearchTerm(value);
    debouncedFeatureTrack(value);
  };

  return (
    <div className="mt-2">
      <SearchInput onChange={handleSearch} placeholder="Search by event name" />
      <EventsStatusButtonGroup />
    </div>
  );
};

export default DashboardFilters;
